var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyLinkIconDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "copy (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21014",
    d: "M16.571 8.857v7.714H8.857V8.857h7.714m0-.857H8.857A.857.857 0 0 0 8 8.857v7.714a.857.857 0 0 0 .857.857h7.714a.857.857 0 0 0 .857-.857V8.857A.857.857 0 0 0 16.571 8z",
    transform: "translate(-5.429 -5.429)",
    style: {
      fill: "#54565b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21015",
    d: "M2.857 8.857H2v-6A.857.857 0 0 1 2.857 2h6v.857h-6z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#54565b"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIconDisable);
export default __webpack_public_path__ + "static/media/copyLinkIconDisable.da85dda27bbc26b57599fcff91eae422.svg";
export { ForwardRef as ReactComponent };